import { useRole } from "@/hooks/useRole";
import { Role } from "@/types/auth";
import { useCashEntry } from "@/contexts/CashEntryContext";
import { useNavigate } from "react-router-dom";
import { useCashEntryApi } from "@/hooks/useCashEntryApi";
import { useAuth } from "@/contexts/AuthContext";
import { useFeatureAccess } from "@/hooks/useFeatureAccess";

export const useNewOrderFlow = () => {
  const navigate = useNavigate();
  const { role } = useRole();
  const { openStartModal } = useCashEntry();
  const { getUnclosedCashEntriesForUser } = useCashEntryApi();
  const { user } = useAuth();
  const { allowed: canCreateOrder } = useFeatureAccess("newOrder");

  const startNewOrder = async () => {
    if (!canCreateOrder) {
      navigate("/");
      return;
    }

    // For shop users, check if there's an open cash entry (any unclosed entry)
    const isShopUser = role === Role.BOUTIQUE || role === Role.FLEURISTE;

    if (isShopUser && user) {
      try {
        const unclosedEntries = await getUnclosedCashEntriesForUser();

        // Check if there's any open cash entry (has start_amount and no end_amount)
        const hasOpenCashEntry = unclosedEntries.some(
          (entry) => entry.start_amount !== null && entry.end_amount === null,
        );

        if (!hasOpenCashEntry) {
          // No open cash entry - must create one before creating orders
          openStartModal({ isMandatory: true, isSkipAllowed: false });
          return;
        }
      } catch (error) {
        console.error("Failed to check cash entry:", error);
        // On error, still require cash entry to be safe
        openStartModal({ isMandatory: true, isSkipAllowed: false });
        return;
      }
    }

    // All checks passed - navigate to order creation
    navigate("/commandes?create=true");
  };

  return { startNewOrder };
};
